<template>
  <LibErrorBoundary component-name="ProductDetailLogoRow">
    <LogoRow
      v-if="logoRowItems.length > 0"
      :items="logoRowItems"
      :height="SPECIFICATION_LOGO_ROW_HEIGHT"
      mode="left"
    />
  </LibErrorBoundary>
</template>

<script setup lang="ts">
import { LogoRow } from '@hypercodestudio/basler-components';
import type { LogoRowItem } from '@hypercodestudio/basler-components';

import type { ResolvedSpecificationLogo } from '~/utils/shop/specificationLogos.types';
import {
  buildSpecificationLogoImage,
  SPECIFICATION_LOGO_ROW_HEIGHT
} from '~/utils/shop/buildSpecificationLogoImage';
import { isDefined } from '~/utils/guards/isDefined';

interface Props {
  specificationLogos: ResolvedSpecificationLogo[];
}

const props = defineProps<Props>();

const logoRowItems = computed<LogoRowItem[]>(() =>
  props.specificationLogos
    .map((logo: ResolvedSpecificationLogo) => {
      const image = buildSpecificationLogoImage(logo.imageUrl, logo.alt);
      if (!image) {
        return undefined;
      }

      return { image };
    })
    .filter(isDefined)
);
</script>
